<template>
  <div class="modal" :class="{'shown': shown}">
    <div class="modal-inner">
      <h2 v-text="name"></h2>
      <slot></slot>
      <button class="close" @click="$emit('close')"><span class="sr-only">Close</span></button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['name', 'shown']
}
</script>

<style lang="scss">
  .modal{
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: $zi-overlay;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color-green,.9);
    color: $color-white;
    opacity: 0;
    pointer-events: none;
    transition: .2s;
    &.shown{
      opacity: 1;
      pointer-events: initial;
      .modal-inner{
        margin-top: 0;
      }
    }
  }
  .modal-inner{
    background: #5B602C url('/assets/bg-pattern-dark.svg');
    padding: 30px;
    box-shadow: 0px 20px 20px rgba(30, 52, 32, 0.2);
    border-radius: 3px;
    position: relative;
    width: 716px;
    max-width: 90%;
    text-align: center;
    margin-top: -30px;
    transition: margin .3s ease;
    @include media-breakpoint-up(md){
      padding: 50px;
    }
    form{
      margin-top: 0;
      text-align: left;
      p{
        margin-bottom: 40px;
        text-align: center;
      }
      .btn{
        width: 100%;
      }
    }
    h2{
      font-size: 40px;
      line-height: 1.2;
      font-weight: 600;
    }
    p{
      font-size: 20px;
    }
    .btn{
      display: inline-block;
      width: auto;
    }
    .close{
      @include resetButton;
      position: absolute;
      top: 0;
      right: 0;
      background: url('/assets/close.svg') no-repeat center center;
      width: 40px;
      height: 40px;
    }
  }
</style>
